import {
    UserModel,
    UserServicCheckExtensionNumberBody,
    UserServiceUpdatePasswordBody,
    AuthServiceLoginResult,
} from '@/types';
import BaseService from '@/services/api/BaseService';
import { AxiosRequestConfig } from 'axios';

class UserService extends BaseService<UserModel> {
    async checkExtensionNumber(checkExtensionNumberBody: UserServicCheckExtensionNumberBody) {
        const { data } = await this.http.post(
            `${this.route}/is-number-extension-available`,
            checkExtensionNumberBody,
        );

        return data;
    }
    async overwritePassword(body: UserServiceUpdatePasswordBody) {
        return this.http.put<AuthServiceLoginResult>(`${this.route}/overwrite-password`, body, {
            headers: {
                authorization: 'Bearer ' + localStorage.getItem('tokenTemp'),
            },
        });
    }
    async resetPassword(loginBody: UserServiceUpdatePasswordBody) {
        return this.http.put<AuthServiceLoginResult>(`${this.route}/reset-password`, loginBody);
    }
    async recoveryPassword(loginBody: UserServiceUpdatePasswordBody) {
        return this.http.post<AuthServiceLoginResult>(`${this.route}/recovery-password`, loginBody);
    }
    async getCsvReport<ResponseT = Blob>(config?: AxiosRequestConfig) {
        return this.http.get<ResponseT>(`${this.route}/report/csv`, config);
    }
}

export default new UserService('users');
